var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 108,
    viewBox: "0 0 16 108",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2929 107.707C7.68342 108.098 8.31659 108.098 8.70711 107.707L15.0711 101.343C15.4616 100.953 15.4616 100.319 15.0711 99.9289C14.6805 99.5384 14.0474 99.5384 13.6569 99.9289L8 105.586L2.34315 99.9289C1.95263 99.5384 1.31946 99.5384 0.928937 99.9289C0.538412 100.319 0.538412 100.953 0.928937 101.343L7.2929 107.707ZM7 4.37114e-08L7 107L9 107L9 -4.37114e-08L7 4.37114e-08Z",
    fill: "#E7E3E1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4b3a276c897ddec1d3b62d52f5192788.svg";
export { ForwardRef as ReactComponent };